module.exports = __webpack_public_path__ + "static/turquoise-983dbe692dc4df3f967c9548e44f0d21.svg";